'use strict';

const settings = require('../settings');

// TODO 還沒定義模組的控管機制，所以直接寫死在這邊。驗證只要改這邊，相關的功能就會自動對應好。
const PAID_MODULES = ['OS', 'ED', 'AM', 'PB', 'AC', 'EP', 'UX', 'SYS', 'RPT', 'CE', 'ZZ'];
let menu = {
	OS: {
		shortName: ['組織', 'Org.', '组织'],
		name: ['組織編制', 'Organization', '组织编制'],
		ico: 'sitemap',
		hint: [
			'「組織編制」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			'Description for "Organization Management" ...',
			'「组织编制」的说明文字的说明文字的说明文字的说明文字的说明文字...',
		],
		children: {
			OS1: {
				name: ['公司管理', 'Company', '公司管理'],
				children: {
					OS10010: {
						name: ['公司資料', 'Basic Setting', '公司资料'],
						url: '/os10010',
						hint: [
							'「公司基本資料設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Organization Basic Setting" ...',
							'「公司基本资料设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					OS10020: {
						name: ['扣繳單位', 'Withholding', '扣缴单位'],
						url: '/os10020',
						hint: [
							'「扣繳單位設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Withholding" ...',
							'「扣缴单位设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					OS10030: {
						name: ['勞保單位', 'Labor Insurance', '劳保单位'],
						url: '/os10030',
						hint: [
							'「勞保投保單位設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Labor Insurance" ...',
							'「劳保投保单位设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					OS10040: {
						name: ['健保單位', 'Health Insurance', '健保单位'],
						url: '/os10040',
						hint: [
							'「健保投保單位設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Health Insurance" ...',
							'「健保投保单位设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			OS2: {
				name: ['組織管理', 'Organization', '组织管理'],
				children: {
					OS20030: {
						name: ['組織圖', 'Org. Chart', '组织图'],
						url: '/os20030',
						hint: ['... (繁中)', '... (English)', '...(简中)'],
						children: {
							OS20030: { name: ['使用中', '', ''] },
							OS20020: { name: ['待生效', '', ''] },
							OS20040: { name: ['歷史', '', ''] },
						},
					},
					OS20050: {
						name: ['主管', 'Dept. Heads', '主管'],
						url: '/os20050',
						hint: ['... (繁中)', '... (English)', '...(简中)'],
					},
					OS20060: {
						name: ['組織及人員查詢', 'Org. Inquiry', '组织及人员查询'],
						url: '/os20060',
						hint: ['... (繁中)', '... (English)', '...(简中)'],
					},
				},
			},
			OS9: {
				name: ['參數管理', 'Parameters', '参数管理'],
				children: {
					OS90020: {
						name: ['組織類別', 'Organization category setting', '组织类别'],
						url: '/os90020',
						hint: [
							'「組織類別設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Organization category setting" ...',
							'「组织类别设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
		},
	},
	ED: {
		shortName: ['人事', 'Staff', '人事'],
		name: ['人事管理', 'Staff', '人事管理'],
		ico: 'users',
		hint: [
			'「人事管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			'Description for "Personnel" ...',
			'「人事管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
		],
		children: {
			ED1: {
				name: ['人事建檔', 'Profile', '人事建档'],
				children: {
					ED10010: {
						name: ['員工資料維護', 'Parameters', '员工资料维护'],
						url: '/ed10010',
						hint: [
							'「員工資料維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee Data Maintenance" ...',
							'「员工资料维护」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						zones: [
							{ code: 'Z10', name: ['基本資料', 'basic information', '基本资料'], freeze: true },
							{ code: 'Z20', name: ['職務年資', 'Seniority', '职务年资'] },
							{ code: 'Z30', name: ['學歷經歷', 'Education experience', '学历经历'] },
							{ code: 'Z40', name: ['護照簽證', 'Passport visa', '护照签证'] },
							{ code: 'Z50', name: ['技能專長', 'Talent', '技能专长'] },
							{ code: 'Z60', name: ['契約保證', 'Contractual guarantee', '契约保证'] },
							{ code: 'Z70', name: ['其他資料', 'other information', '其他资料'] },
							{
								code: 'Z80',
								name: ['派遣/建教合作', 'Dispatch / Education Cooperation', '派遣/建教合作'],
							},
							{ code: 'Z90', name: ['異動歷程', 'Change history', '异动历程'] }
						],
					},
					ED10020: {
						name: ['員工證照', 'Employee license maintenance', '员工证照'],
						url: '/ed10020',
						hint: [
							'「員工證照維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee license maintenance" ...',
							'「员工证照维护」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					ED10030: {
						name: ['員工訓練', 'Emp Training', '员工训练'],
						url: '/ed10030',
						hint: [
							'「員工訓練維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Emp Training" ...',
							'「员工训练维护」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					ED10040: {
						name: ['員工績效', 'Employee performance maintenance', '员工绩效'],
						url: '/ed10040',
						hint: [
							'「員工績效維護」的說明文字的說明文字的說明文字的說明文字的說明文字......',
							'Description for "Employee performance maintenance" ...',
							'「员工绩效维护」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					ED10050: {
						name: ['員工獎懲', 'Parameters', '员工奖惩'],
						url: '/ed10050',
						hint: [
							'「員工獎懲維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee Data Maintenance" ...',
							'「员工奖惩维护」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					ED20020: {
						name: ['員工晉升', 'Parameters', '员工晋升'],
						url: '/ed20020',
						hint: [
							'「員工晉升紀錄」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee Data Maintenance" ...',
							'「员工晋升纪录」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},

			ED3: {
				name: ['人事異動', 'Change', '人事异动'],
				children: {
					ED30010: {
						name: ['試用期作業', '試用期作業', '試用期作業'],
						url: '/ed30010',
						hint: [
							'「試用期作業」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Parameters" ...',
							'「試用期作業」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					ED30020: {
						name: ['異動作業', 'Employee change operation', '异动作业'],
						url: '/ed30020',
						hint: [
							'「員工異動作業」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee change operation" ...',
							'「员工异动作业」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					ED30030: {
						name: ['留職停薪作業', 'Leave a job without pay', '留职停薪作业'],
						url: '/ed30030',
						hint: [
							'「留職停薪作業」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee Data Maintenance" ...',
							'「留职停薪作业」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							ED30030: { name: ['留職停薪作業', '', ''] },
							ED30035: { name: ['育嬰留停資格查詢', '', ''] },
						}
					},
					ED30040: {
						name: ['離職作業', 'Parameters', '离职作业'],
						url: '/ed30040',
						hint: [
							'「離職作業」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee Data Maintenance" ...',
							'「离职作业」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					ED30050: {
						name: ['復職作業', 'Employee reinstatement', '复职作业'],
						url: '/ed30050',
						hint: [
							'「員工復職作業」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Employee reinstatement ...',
							'「员工复职作业」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			ED9: {
				name: ['參數管理', 'Configuration', '参数管理'],
				children: {
					ED90010: {
						name: ['育嬰留停設定', 'Parental leave settings', '育婴留停设定'],
						url: '/ed90010',
						hint: [
							'「育嬰留停設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "育嬰留停設定" ...',
							'「育嬰留停設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							ED90010: { name: ['育嬰留停設定', '', ''] },
							ED90015: {
								name: ['自動復職預設值', 'Automatic reinstatement default value', '自动复职预设值'],
							},
						}
					},
					ED90020: {
						name: ['代碼維護', 'Parameters', '代码维护'],
						url: '/ed90020',
						hint: [
							'「代碼資料維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Parameters" ...',
							'「代码资料维护」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					ED90100: {
						name: ['訊息通知', 'Notifications', '讯息通知'],
						url: '/ed90100',
						hint: [
							'「訊息通知」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Notifications" ...',
							'「讯息通知」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					// ED90030: {
					// 	name: ['人員群組', 'User Groups', '人员群组'],
					// 	url: '/ed90030',
					// 	hint: [
					// 		'「人員群組設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "User Groups" ...',
					// 		'「代码资料维护」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },

				},
			},
			ED10: {
				hide: true,
				name: ['', '', ''],
				children: {
					UX20010: {
						name: ['系統訊息', '系統訊息', '系統訊息'],
						url: '/ed220010',
						hint: [
							'「系統訊息」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Sign-in Policy" ...',
							'「系統訊息」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				}
			}

		},
	},
	AM: {
		shortName: ['出勤', 'Work', '出勤'],
		name: ['出勤管理', 'Working Attendance', '出勤管理'],
		ico: 'suitcase',
		hint: [
			'「出勤管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			'Description for "Attendance" ...',
			'「出勤管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
		],
		children: {
			AM2: {
				code: 'AM2',
				name: ['出勤管理', 'Employee attendance rules management', '出勤管理'],
				children: {
					AM20010: {
						name: ['員工出勤規則', 'Attendance rules maintenance', '员工出勤规则'],
						url: '/am20010',
						hint: [
							'「員工出勤規則維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工出勤規則維護" ...',
							'「員工出勤規則維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM20010: { name: ['員工規則', '', ''] },
							AM20015: { name: ['規則範本', '', ''] },
						},
					},
					// _AM20010: {
					// 	name: ['員工出勤規則(old)', 'Attendance rules maintenance(old)', '员工出勤规则(old)'],
					// 	url: '/_am20010',
					// 	hint: [
					// 		'「員工出勤規則維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "員工出勤規則維護" ...',
					// 		'「員工出勤規則維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					AM20020: {
						name: ['出勤規則異動', 'Attendance rules change jobs', '出勤规则异动'],
						url: '/am20020',
						hint: [
							'「出勤規則異動作業」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "出勤規則異動作業" ...',
							'「出勤規則異動作業」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM20030: {
						name: ['卡號異動', 'Employee card number change operation', '卡号异动'],
						url: '/am20030',
						hint: [
							'「員工卡號異動作業」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee card number change operation" ...',
							'「员工卡号异动作业」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM20040: {
						name: ['員工例假調整', 'Employee holiday leave adjustment settings', '员工例假调整'],
						url: '/am20040',
						hint: [
							'「員工例假調整設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee holiday leave adjustment settings" ...',
							'「员工例假调整设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			AM4: {
				code: 'AM4',
				name: ['打卡', 'Basic', '打卡'],
				children: {
					AM40010: {
						name: ['員工臨時卡維護', '員工臨時卡維護', '員工臨時卡維護'],
						url: '/am40010',
						hint: [
							'「員工臨時卡維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "打卡比對維護" ...',
							'「員工臨時卡維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM40020: {
						name: ['打卡比對', '打卡比對', '打卡比對'],
						url: '/am40020',
						hint: [
							'「打卡比對維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "打卡比對維護" ...',
							'「打卡比對維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM40030: {
						name: ['打卡明細', '打卡明細', '打卡明細'],
						url: '/am40030',
						hint: [
							'「打卡明細管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "打卡明細管理" ...',
							'「打卡明細管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM40040: {
						name: ['出勤確認管理', '出勤確認管理', '出勤確認管理'],
						url: '/am40040',
						hint: [
							'「出勤確認管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "出勤確認管理" ...',
							'「出勤確認管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			AM5: {
				code: 'AM5',
				name: ['假勤申請', '假勤申請', '假勤申請'],
				children: {
					AM50010: {
						name: ['請假', '請假', '請假'],
						url: '/am50010',
						hint: [
							'「請假維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "請假維護" ...',
							'「請假維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM50020: {
						name: ['加班', '加班', '加班'],
						url: '/am50020',
						hint: [
							'「加班維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "加班維護" ...',
							'「加班維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM50020: {
								name: ['加班', '加班', '加班'],
								url: '/am50020',
								hint: [
									'「加班維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "加班維護" ...',
									'「加班維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
							AM50025: {
								name: ['預先加班', 'Petition before overtime', '预先加班'],
								url: '/am50025',
								hint: [
									'「預先加班」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "Petition before overtime" ...',
									'「预先加班」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
						},
					},
					AM50060: {
						name: ['銷假', '銷假', '銷假'],
						url: '/am50060',
						hint: [
							'「銷假維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "加班維護" ...',
							'「銷假維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM50030: {
						name: ['出勤時數', 'Attendance hours', '出勤时数'],
						url: '/am50030',
						hint: [
							'「出勤時數」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Attendance hours" ...',
							'「出勤时数」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM50030: {
								name: ['出勤時數', 'Attendance hours', '出勤时数'],
								url: '/am50030',
								hint: [
									'「出勤時數」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "Attendance hours" ...',
									'「出勤时数」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
							AM50035: {
								name: ['打卡轉出勤及加班', 'Check-in and transfer attendance and overtime', '打卡转出勤及加班'],
								url: '/am50035',
								hint: [
									'「打卡轉出勤及加班」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "Attendance hours" ...',
									'「打卡转出勤及加班」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
						},
					},
				},
			},
			AM3: {
				code: 'AM3',
				name: ['排班', '排班', '排班'],
				children: {
					AM30100: {
						name: ['排班', '排班', '排班'],
						url: '/am30100',
						hint: [
							'「排班」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "排班" ...',
							'「排班」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM30200: {
						name: ['員工班表查詢', '員工班表查詢', '員工班表查詢'],
						url: '/am30200',
						hint: [
							'「員工班表查詢」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工班表查詢" ...',
							'「員工班表查詢」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM30300: {
						name: ['排班人力統計', '排班人力統計', '排班人力統計'],
						url: '/am30300',
						hint: [
							'「排班人力統計」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "排班人力統計" ...',
							'「排班人力統計」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM30300: {
								name: ['班別人力統計', '', ''],
								url: '/am30300',
								hint: [
									'「班別人力統計」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "班別人力統計" ...',
									'「班別人力統計」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
							AM30310: {
								name: ['時段人力統計', '', ''],
								url: '/am30310',
								hint: [
									'「時段人力統計」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "時段人力統計" ...',
									'「時段人力統計」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
						},
					},
					AM30410: {
						name: ['員工管理', 'Employee Mgmt', '员工管理'],
						url: '/am30410',
						hint: [
							'「員工管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工管理" ...',
							'「員工管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			AM7: {
				code: 'AM7',
				name: ['假勤管理', '假勤管理', '假勤管理'],
				children: {
					AM70010: {
						name: ['假勤總覽', '假勤總覽', '假勤總覽'],
						url: '/am70010',
						hint: [
							'「假勤總覽管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "假勤總覽管理" ...',
							'「假勤總覽管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM70020: {
						name: ['特休假管理', '特休假管理', '特休假管理'],
						url: '/am70020',
						hint: [
							'「特休假管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "特休假管理" ...',
							'「特休假管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					// AM70060: {
					// 	name: ['公司假管理', '公司假管理', '公司假管理'],
					// 	url: '/am70060',
					// 	hint: [
					// 		'「公司假管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "公司假管理" ...',
					// 		'「公司假管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					AM70030: {
						name: ['補休假管理', '補休假管理', '補休假管理'],
						url: '/am70030',
						hint: [
							'「補休假管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "補休假管理" ...',
							'「補休假管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM70040: {
						name: ['彈性假管理', '彈性假管理', '彈性假管理'],
						url: '/am70040',
						hint: [
							'「彈性假管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "彈性假管理" ...',
							'「彈性假管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			AM6: {
				code: 'AM6',
				name: ['結算管理', '結算管理(EN)', '結算管理(CN)'],
				children: {
					AM60030: {
						name: ['離職留停結算', '離職留停結算(EN)', '離職留停結算(CN)'],
						url: '/am60030',
						hint: [
							'「離職留停結算」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "離職留停結算" ...',
							'「離職留停結算」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM60040: {
						name: ['年度結算', '年度結算(EN)', '年度結算(CN)'],
						url: '/am60040',
						hint: [
							'「年度結算」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "年度結算" ...',
							'「年度結算」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM60020: {
						name: ['排班工時結算', 'Shift hours reckon', '排班工时结算'],
						url: '/am60020',
						hint: [
							'「排班結算」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Shift reckon" ...',
							'「排班结算」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM60020: {
								name: ['排班工時結算啟動', 'Shift hours start reckon', '排班工时结算启动'],
								url: '/am60020',
								hint: [],
							},
							AM60025: {
								name: ['排班工時結算鎖檔', 'Shift hours lock reckon', '排班工时结算锁档'],
								url: '/am60025',
								hint: [],
							},
						},
					},
				},
			},
			AM1: {
				code: 'AM1',
				name: ['參數管理', 'Parameter', '参数管理'],
				children: {
					AM10150: {
						name: ['起始日規則', 'Start Time', '起始日規則'],
						url: '/am10150',
						hint: [
							'「起始日規則」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Basic" ...',
							'「起始日規則」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AM10020: {
						name: ['工作時間設定', 'Working Time', '工作时间设定'],
						url: '/am10020',
						hint: [
							'「工作時間設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Working Time" ...',
							'「工作时间设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM10020: { name: ['班別時間', '', ''] },
							AM10200: { name: ['時段班別設定', '', ''] },
							AM10025: { name: ['班別規則', '', ''] },
						},
					},
					AM10050: {
						name: ['行事曆', 'Calendar', '行事历'],
						url: '/am10050',
						hint: [
							'「行事曆」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Calendar" ...',
							'「行事历」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM10050: { name: ['行事曆', '', ''] },
							AM10060: { name: ['假節日規則', '', ''] },
							AM10070: { name: ['行事曆別', '', ''] },
						},
					},
					AM10610: {
						name: ['排班設定', 'Shifting', '排班设定'],
						url: '/am10610',
						hint: [
							'「排班設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Shifting" ...',
							'「排班设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM10610: {
								name: ['排班群組', 'Groups', '排班群组'],
								url: '/am10610',
								hint: [
									'「排班群組」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "Groups" ...',
									'「排班群组」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
							AM10620: {
								name: ['排班標籤', '排班標籤', '排班標籤'],
								url: '/am10620',
								hint: [
									'「排班標籤」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "排班標籤" ...',
									'「排班標籤」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
							AM10630: {
								name: ['發佈設定', '發佈設定', '發佈設定'],
								url: '/am10630',
								hint: [
									'「發佈設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "發佈設定" ...',
									'「發佈設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
							AM10640: {
								name: ['應排工時設定', '應排工時設定', '應排工時設定'],
								url: '/am10640',
								hint: [
									'「應排工時設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "發佈設定" ...',
									'「應排工時設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
							AM10650: {
								name: ['國定假日挪移', '國定假日挪移', '國定假日挪移'],
								url: '/am10650',
								hint: [
									'「國定假日挪移」的說明文字的說明文字的說明文字的說明文字的說明文字...',
									'Description for "發佈設定" ...',
									'「國定假日挪移」的说明文字的说明文字的说明文字的说明文字的说明文字...',
								],
							},
						},
					},
					AM10110: {
						name: ['假勤設定', '假勤參數', '假勤設定'],
						url: '/am10110',
						hint: [
							'「假勤參數」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Calendar" ...',
							'「假勤參數」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM10110: { name: ['一般假勤', '', ''] },
							AM10115: { name: ['部分工時一般假勤', '', ''] },
							AM10120: { name: ['個人假', '', ''] },
							AM10130: { name: ['特休假', '', ''] },
							// AM10131: { name: ['公司假', '', ''] },
							AM10140: { name: ['彈性假', '', ''] },
							AM10180: { name: ['特休例外折抵', '', ''] },
							AM10190: { name: ['職務代理人條件', '', ''] },
						},
					},
					AM10210: {
						name: ['加班設定', 'Overtime category setting', '加班设定'],
						url: '/am10210',
						hint: [
							'「加班參數設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Overtime category setting" ...',
							'「加班参数设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM10210: { name: ['加班類別', '', ''] },
							AM10220: { name: ['加班規則', '', ''] },
							AM10230: { name: ['特殊日倍率', '', ''] },
							AM10240: { name: ['開放加班時段', '', ''] },
							AM10250: { name: ['超時出勤原因', '', ''] },
						},
					},
					AM10170: {
						name: ['部分工時設定', 'Some working hours', '部分工時設定'],
						url: '/am10170',
						hint: [
							'「部分工時設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Some working hours" ...',
							'「部分工時設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM10170: { name: ['出勤時數規則', '', ''] },
						},
					},
					AM10310: {
						name: ['工時規則', 'Working hours management', '工时规则'],
						url: '/am10310',
						hint: [
							'「工時規則管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Working hours management" ...',
							'「工时规则管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM10310: { name: ['工時規則', '', ''] },
							AM10320: { name: ['例外設定', '', ''] },
						},
					},
					AM10410: {
						name: ['打卡設定', 'Card', '打卡設定'],
						url: '/am10410',
						hint: [
							'「打卡參數」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Card" ...',
							'「打卡参数」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							AM10410: { name: ['卡鐘代碼', '', ''] },
							AM10420: { name: ['匯入格式', '', ''] },
							AM10430: { name: ['匯入排程', '', ''] },
							AM10440: { name: ['GPS打卡', '', ''] },
							AM10450: { name: ['網路打卡', '', ''] },
							AM10460: { name: ['Wi-Fi打卡', '', ''] },
							AM10470: { name: ['例外人員打卡', '', ''] },
							AM10480: { name: ['比對排程', '', ''] },
							AM10490: { name: ['打卡體溫設定', '', ''] },
						},
					},
					AM90100: {
						name: ['訊息通知', 'Notifications', '讯息通知'],
						url: '/am90100',
						hint: [
							'「訊息通知」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Notifications" ...',
							'「讯息通知」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
		},
	},
	PB: {
		shortName: ['薪資', 'Payroll', '薪资'],
		name: ['薪資管理', 'Payroll', '薪资管理'],
		ico: 'envelope-open-dollar',
		hint: [
			'「薪資管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			'Description for "Staff Payroll" ...',
			'「薪资管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
		],
		children: {
			PB2: {
				name: ['員工薪資', '員工薪資', '員工薪資'],
				children: {
					PB20110: {
						name: ['員工薪資規則', '員工薪資規則', '員工薪資規則'],
						url: '/pb20110',
						hint: [
							'「員工薪資規則維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「員工薪資規則維護」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB20110: { name: ['員工規則', '', ''] },
							PB10810: { name: ['規則範本', '', ''] },
							PB10820: { name: ['結構範本', '', ''] },
						},
					},
					// PB20160: {
					// 	name: ['員工投保現況', '員工投保現況', '員工投保現況'],
					// 	url: '/pb20160',
					// 	hint: [
					// 		'「員工投保現況」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "員工薪資規則維護" ...',
					// 		'「員工投保現況」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					PB20120: {
						name: ['薪資規則異動', '薪資規則異動', '薪資規則異動'],
						url: '/pb20120',
						hint: [
							'「薪資規則異動」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「薪資規則異動」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					PB20130: {
						name: ['調薪異動', '調薪異動', '調薪異動'],
						url: '/pb20130',
						hint: [
							'「調薪異動」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「調薪異動」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					PB20140: {
						name: ['成本中心異動', '成本中心異動', '成本中心異動'],
						url: '/pb20140',
						hint: [
							'「成本中心異動」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「成本中心異動」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					PB20150: {
						name: ['員工法院強制執行', '員工法院強制執行', '員工法院強制執行'],
						url: '/pb20150',
						hint: [
							'「員工法院強制執行」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「員工法院強制執行」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					// webpack5 才支援 optional condition，現在是透過 babel-loader 達成
					...settings?.nodes?.zz10060 && {
						ZZ10060: {
							name: ['薪管轉檔(非薪管人員勿用)', 'Payroll transfer', '薪管转档'],
							url: '/zz10060',
							hint: ['薪管轉檔(非薪管人員勿用)', 'Payroll transfer', '薪管转档'],
						},
					},
				},
			},
			PB3: {
				name: ['保險', '保險', '保險'],
				children: {
					PB30110: {
						name: ['整合保險', '整合保險', '整合保險'],
						url: '/pb30110',
						hint: [
							'「整合保險」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「整合保險」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB30110: { name: ['加保(轉入)', '', ''] },
							PB30120: { name: ['退保(轉出)', '', ''] },
							PB30130: { name: ['投保薪資調整', '', ''] },
							PB30140: { name: ['投保身分調整', '', ''] },
							PB30150: { name: ['暫停加保人員', '', ''] },
						},
					},
					PB30210: {
						name: ['勞工保險', '勞工保險', '勞工保險'],
						url: '/pb30210',
						hint: [
							'「勞工保險」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「勞工保險」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB30210: {
								name: ['投保異動', '', ''],
								zones: [
									{ code: 'Z11', name: ['加保', 'Additional insurance', '加保'], freeze: true },
									{ code: 'Z12', name: ['轉入', 'Transfer in', '转入'] },
									{ code: 'Z21', name: ['退保', 'Surrender', '退保'] },
									{ code: 'Z22', name: ['轉出', 'Transfer out', '转出'] },
									{ code: 'Z81', name: ['留職停薪續保', 'Renewal without pay', '留职停薪续保'] },
									{
										code: 'Z82',
										name: ['留職停薪復職', 'Reinstatement without pay', '留职停薪复职'],
									},
									{
										code: 'Z3132',
										name: ['投保薪資調整', 'Insured salary adjustment', '投保薪资调整'],
									}
								],
							},
							PB30220: { name: ['勞保保費', '', ''] },
							/*	PB30230: { name: ['公司應繳保費', '', ''] },*/
						},
					},
					PB30310: {
						name: ['全民健保', '全民健保', '全民健保'],
						url: '/pb30310',
						hint: [
							'「全民健保」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「全民健保」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB30310: {
								name: ['投保異動', '', ''],
								zones: [
									{ code: 'Z11', name: ['加保', 'Additional insurance', '加保'], freeze: true },
									{ code: 'Z2122', name: ['退保', 'Surrender', '退保'] },
									{
										code: 'Z3132',
										name: ['投保薪資調整', 'Insured salary adjustment', '投保薪资调整'],
									},
									{ code: 'Z41', name: ['停保', 'Suspension of insurance', '停保'] },
									{ code: 'Z42', name: ['復保', 'Reinsurance', '复保'] }
								],
							},
							PB30320: { name: ['健保保費', '', ''] },
							PB30330: { name: ['員工補充保費', '', ''] },
							PB30340: { name: ['兼職員工補充保費', '', ''] },
							PB30350: { name: ['公司補充保費', '', ''] },
						},
					},
					PB30410: {
						name: ['勞工退休金', '勞工退休金', '劳工退休金'],
						url: '/pb30410',
						hint: [
							'「勞工退休金」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "勞工退休金" ...',
							'「劳工退休金」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB30410: {
								name: ['勞退提繳異動', '', ''],
								zones: [
									{ code: 'Z11', name: ['加保', 'Additional insurance', '加保'], freeze: true },
									{ code: 'Z12', name: ['轉入', 'Transfer in', '转入'] },
									{
										code: 'Z13',
										name: ['提繳率加保', 'Withholding rate plus guarantee', '提缴率加保'],
									},
									{ code: 'Z21', name: ['退保', 'Surrender', '退保'] },
									{ code: 'Z22', name: ['轉出', 'Transfer out', '转出'] },
									{ code: 'Z23', name: ['停止提繳', 'Stop withdrawing', '停止提缴'] },
									{
										code: 'Z3132',
										name: ['提繳工資調整', 'Withholding salary adjustment', '提缴工资调整'],
									},
									{ code: 'Z61', name: ['提繳率調整', 'Withholding rate adjustment', '提缴率调整'] }
								],
							},
							PB30420: { name: ['勞退提繳金額', '', ''] },
						},
					},
				},
			},
			PB4: {
				name: ['薪資計算', '薪資計算', '薪資計算'],
				children: {
					PB40110: {
						name: ['薪資', '薪資', '薪資'],
						url: '/pb40110',
						hint: [
							'「薪資」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「薪資」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB40110: { name: ['加扣項', '', ''] },
							PB40130: { name: ['員工薪資計算', '', ''] },
							PB40150: { name: ['結檔薪資', '', ''] },
							PB40160: { name: ['薪資鎖定', '', ''] },
						},
					},

					PB40210: {
						name: ['獎金', '獎金', '獎金'],
						url: '/pb40210',
						hint: [
							'「獎金」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「獎金」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB40210: { name: ['獎金作業', '', ''] },
							PB40240: { name: ['獎金明細', '', ''] },
						},
					},

					PB40910: {
						name: ['發放作業', '發放作業', '發放作業'],
						url: '/pb40910',
						hint: [
							'「全民健保」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「全民健保」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB40910: { name: ['員工薪資袋管理', '', ''] },
							PB40920: { name: ['薪資袋發放', '', ''] },
							PB40930: { name: ['薪資止付', '', ''] },
							PB40940: { name: ['銀行轉帳', '', ''] },
						},
					},
				},
			},
			PB9: {
				name: ['所得稅', '所得稅', '所得稅'],
				children: {
					PB90110: {
						name: ['員工各類所得', '員工各類所得', '員工各類所得'],
						url: '/pb90110',
						hint: [
							'「員工各類所得」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「員工各類所得」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB90110: { name: ['員工薪資所得', '', ''] },
							PB90120: { name: ['員工非薪資所得', '', ''] },
							PB90130: { name: ['福利金明細', '', ''] },
						},
					},

					PB90210: {
						name: ['非員工各類所得', '非員工各類所得', '非員工各類所得'],
						url: '/pb90210',
						hint: [
							'「非員工各類所得」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「非員工各類所得」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB90210: { name: ['非員工基本資料', '', ''] },
							PB90220: { name: ['非員工薪資所得', '', ''] },
							PB90230: { name: ['非員工非薪資所得', '', ''] },

						},
					},

					PB90410: {
						name: ['所得稅申報', '所得稅申報', '所得稅申報'],
						url: '/pb90410',
						hint: [
							'「所得稅申報」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "員工薪資規則維護" ...',
							'「所得稅申報」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB90410: { name: ['年度申報-薪資', '', ''] },
							PB90420: { name: ['年度申報-非薪資', '', ''] },
							PB90430: { name: ['每月申報-薪資', '', ''] },
							PB90440: { name: ['每月申報-非薪資', '', ''] },
							PB90450: { name: ['所得稅彙總', '', ''] },
						},
					},
				},
			},
			PB1: {
				name: ['參數管理', '參數管理', '參數管理'],
				children: {
					PB10110: {
						name: ['薪資科目', '薪資科目', '薪資科目'],
						url: '/pb10110',
						hint: [
							'「薪資科目管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "薪資科目管理" ...',
							'「薪資科目管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB10110: { name: ['薪資科目', '', ''] },
							PB10150: { name: ['薪資科目基礎', '', ''] },
							PB10140: { name: ['薪資科目預設金額', '', ''] },
							PB10120: { name: ['工資計算基礎', '', ''] },

						},
					},
					PB10210: {
						name: ['薪資計算規則', '薪資計算規則', '薪資計算規則'],
						url: '/pb10210',
						hint: [
							'「薪資計算規則」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "計薪規則管理1" ...',
							'「薪資計算規則」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB10210: { name: ['計薪週期', '', ''] },
							PB10220: { name: ['基本薪資規則', '', ''] },
							PB10260: { name: ['加班費規則', '', ''] },
							PB10270: { name: ['加班調整期間', '', ''] },
							PB10250: { name: ['請假扣款規則', '', ''] },
							PB10240: { name: ['法扣最低生活費', '', ''] },
						},
					},
					PB10310: {
						name: ['津貼扣款規則', '津貼扣款規則', '津貼扣款規則'],
						url: '/pb10310',
						hint: [
							'「津貼扣款規則」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "計薪規則管理1" ...',
							'「津貼扣款規則」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB10310: { name: ['全勤獎金規則', '', ''] },
							PB10320: { name: ['輪班津貼規則', '', ''] },
							PB10330: { name: ['誤餐費規則', '', ''] },
							PB10340: { name: ['刷卡異常扣薪規則', '', ''] },
							PB10350: { name: ['強制儲蓄規則', '', ''] },
							// PB10360: { name: ['借發薪資規則', '', ''] },
						},
					},
					PB10410: {
						name: ['保險規則', '保險規則', '保險規則'],
						url: '/pb10410',
						hint: [
							'「保險規則」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "保險參數管理" ...',
							'「保險規則」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB10410: { name: ['勞工保險', '', ''] },
							PB10420: { name: ['全民健保', '', ''] },
							PB10430: { name: ['勞工退休金', '', ''] },
							PB10440: { name: ['補充保費', '', ''] },
							PB10450: { name: ['保險補助規則', '', ''] },
							PB10610: { name: ['舊制退休金', '', ''] },
						},
					},
					PB10510: {
						name: ['所得稅規則', '所得稅規則', '所得稅規則'],
						url: '/pb10510',
						hint: [
							'「所得稅參數」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "所得稅參數管理" ...',
							'「所得稅參數」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB10510: { name: ['所得稅規則', '', ''] },
							PB10530: { name: ['扣除福利金優先順序', '', ''] },
						},
					},
					// PB10620: {
					// 	name: ['退休資遣參數管理', '退休資遣參數管理', '退休資遣參數管理'],
					// 	url: '/pb10620',
					// 	hint: [
					// 		'「退休資遣參數管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "所得稅參數管理" ...',
					// 		'「退休資遣參數管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					PB10720: {
						name: ['計薪其它規則', 'Other parameter management', '計薪其它規則'],
						url: '/pb10720',
						hint: [
							'「其他參數管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Other parameter management" ...',
							'「其他参数管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB10720: { name: ['銀行轉帳格式', '', ''] },
							PB10730: { name: ['匯率變量', '', ''] },
							PB10740: { name: ['成本中心預設規則', '', ''] },
						},
					},
					PB10910: {
						name: ['薪資袋管理', 'Payroll management', '薪资袋管理'],
						url: '/pb10910',
						hint: [
							'「薪資袋管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Other parameter management" ...',
							'「薪資袋管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							PB10910: { name: ['薪資袋語言', '', ''] },
							PB10940: { name: ['薪資袋格式', '', ''] },
							// PB10920: { name: ['薪資袋明細設定', '', ''] },
							PB10950: { name: ['薪資袋留言', '', ''] },
							PB10930: { name: ['電子薪資袋密碼', '', ''] },
						},
					},
					PB10710: {
						name: ['代碼維護', 'Parameters', '代码维护'],
						url: '/pb10710',
						hint: [
							'「代碼資料維護」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Parameters" ...',
							'「代码资料维护」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					PB90100: {
						name: ['訊息通知', 'Notifications', '讯息通知'],
						url: '/pb90100',
						hint: [
							'「訊息通知」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Notifications" ...',
							'「讯息通知」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
		},
	},
	AC: {
		shortName: ['權限', 'Privilege', '權限'],
		name: ['系統權限', 'Privilege', '系统权限'],
		ico: 'cog',
		hint: [
			'「系統權限」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			'Description for "System Configuration" ...',
			'「系统权限」的说明文字的说明文字的说明文字的说明文字的说明文字...',
		],
		children: {
			AC1: {
				name: ['權限設定', 'Privilege', '权限设定'],
				children: {
					AC10010: {
						name: ['登入規則設定', 'Sing-in Policy', '登入规则设定'],
						url: '/ac10010',
						hint: [
							'「登入規則設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Sign-in Policy" ...',
							'「登入规则设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AC10020: {
						name: ['成員群組設定', 'User Group', '成员群组设定'],
						url: '/ac10020',
						hint: [
							'「成員群組設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "User Group" ...',
							'「成员群组设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AC10030: {
						name: ['角色設定', 'Role', '角色设定'],
						url: '/ac10030',
						hint: [
							'「角色設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Role" ...',
							'「角色设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AC10040: {
						name: ['帳號管理', 'Account', '帐号管理'],
						url: '/ac10040',
						hint: [
							'「帳號管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Account" ...',
							'「帐号管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			AC2: {
				name: ['操作日誌', 'Log', '操作日志'],
				children: {
					AC20010: {
						name: ['使用者登錄日誌', '使用者登錄日誌', '使用者登錄日誌'],
						url: '/ac20010',
						hint: [
							'「使用者登錄日誌」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Sign-in Policy" ...',
							'「使用者登錄日誌」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					AC20020: {
						name: ['使用者操作日誌', '使用者操作日誌', '使用者操作日誌'],
						url: '/ac20020',
						hint: [
							'「使用者操作日誌」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Sign-in Policy" ...',
							'「使用者操作日誌」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			AC9: {
				hide: true,
				name: ['', '', ''],
				children: {
					AC90010: {
						name: ['帳號設定', '帳號設定EN', '帳號設定CN'],
						url: '/ac90010',
						hint: ['帳號設定hint', '帳號設定hintEN', '帳號設定hintCN'],
					},
				},
			}
		},
	},
	UX: {
		hide: true,
		shortName: ['', '', ''],
		name: ['', '', ''],
		ico: 'cog',
		hint: [
			'',
			'',
			'',
		],
		children: {
			UX2: {
				name: ['', '', ''],
				children: {
					UX20010: {
						name: ['系統通知', '系統通知EN', '系統通知CN'],
						url: '/ux20010',
						hint: ['系統通知hint', '系統通知hintEN', '系統通知hintCN'],
					},
				}
			},
			UX3: {
				name: ['', '', ''],
				children: {
					UX30010: {
						hide: true,
						name: ['系統設定', '系統設定EN', '系統設定CN'],
						url: '/ux30010',
						hint: ['系統資訊hint', '系統資訊hintEN', '系統資訊hintCN'],
					},
					UX30020: {
						name: ['系統設定', '系統設定EN', '系統設定CN'],
						url: '/ux30020',
						hint: ['', '', ''],
					},
				}
			},
			UX4: {
				name: ['', '', ''],
				children: {
					ux40010: {
						hide: true,
						name: ['帳務資訊', '帳務資訊EN', '帳務資訊CN'],
						url: '/ux40010',
						hint: ['帳務資訊hint', '帳務資訊hintEN', '帳務資訊hintCN'],
					},
				},
			},
		},
	},
	SYS: {
		hide: true,
		shortName: ['', '', ''],
		name: ['', '', ''],
		ico: 'cog',
		hint: ['', '', ''],
		children: {
			SYS3: {
				name: ['', '', ''],
				children: {
					SYS30030: {
						name: ['系統設定', '系統設定EN', '系統設定CN'],
						url: '/sys30030',
						hint: ['', '', ''],
					},
					SYS30040: {
						name: ['系統設定', '系統設定EN', '系統設定CN'],
						url: '/sys30040',
						hint: ['', '', ''],
					},
					SYS30050: {
						name: ['系統設定', '系統設定EN', '系統設定CN'],
						url: '/sys30050',
						hint: ['', '', ''],
					},
				},
			},
		},
	},
	EP: {
		shortName: ['Portal', 'Portal', 'Portal'],
		name: ['Portal', 'Portal', 'Portal'],
		ico: 'globe',
		hint: [
			'「Portal」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			'Description for "Portal" ...',
			'「Portal」的说明文字的说明文字的说明文字的说明文字的说明文字...',
		],
		children: {
			// EP1: {
			// 	name: ['公共事務區管理', '公共事務區管理[英文]', '公共事務區管理'],
			// 	children: {
			// 		EP10110: {
			// 			name: ['會議室管理', '會議室管理[英文]', '會議室管理'],
			// 			url: '/ep10110',
			// 			hint: [
			// 				'「會議室管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			// 				'Description for "會議室管理" ...',
			// 				'「會議室管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
			// 			],
			// 		},
			// 	},
			// },
			EP2: {
				name: ['表單管理', '表單管理[英文]', '表單管理'],
				children: {
					EP20110: {
						name: ['表單設定', '表單設定[英文]', '表單設定'],
						url: '/ep20110',
						hint: [
							'「表單設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "表單設定" ...',
							'「表單設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							EP20110: { name: ['表單類別', '', ''] },
							EP20120: { name: ['標準表單', '', ''] },
							EP20140: { name: ['自訂表單', '', ''] },
							EP20130: { name: ['封存表單', '', ''] },
						},
					},
					EP20210: {
						name: ['簽核通知', '簽核通知[英文]', '簽核通知'],
						url: '/ep20210',
						hint: [
							'「簽核通知」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "簽核通知" ...',
							'「簽核通知」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							EP20210: { name: ['規則設定', '', ''] },
							EP20230: { name: ['彙整通知', '', ''] },
						},
					},
					EP20310: {
						name: ['代理人設定', '代理人設定[英文]', '代理人設定'],
						url: '/ep20310',
						hint: [
							'「代理人設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "用戶設定" ...',
							'「代理人設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					EP20320: {
						name: ['簽核角色設定', '簽核角色設定[英文]', '簽核角色設定'],
						url: '/ep20320',
						hint: [
							'「簽核角色設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "簽核角色設定" ...',
							'「簽核角色設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					// EP20410: {
					// 	name: ['角色設定', '角色設定[英文]', '角色設定'],
					// 	url: '/ep20410',
					// 	hint: [
					// 		'「角色設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "群組設定" ...',
					// 		'「角色設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
				},
			},
			EP3: {
				name: ['個人專區', '個人專區[英文]', '個人專區'],
				children: {
					EP30110: {
						name: ['維護資料欄位設定', '維護資料欄位設定[英文]', '維護資料欄位設定'],
						url: '/ep30110',
						hint: [
							'「維護資料欄位設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "維護資料欄位設定" ...',
							'「維護資料欄位設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							EP30110: { name: ['資料審核', '', ''] },
							EP30120: { name: ['維護資料欄位設定', '', ''] },
							EP30130: { name: ['通知設定', '', ''] },
						},
					},
					// EP30210: {
					// 	name: ['薪資袋管理', '薪資袋管理[英文]', '薪資袋管理'],
					// 	url: '/ep30210',
					// 	hint: [
					// 		'「薪資袋管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "薪資袋管理" ...',
					// 		'「薪資袋管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					EP30220: {
						name: ['扣繳憑單管理', '扣繳憑單管理[英文]', '扣繳憑單管理'],
						url: '/ep30220',
						hint: [
							'「扣繳憑單管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "扣繳憑單管理" ...',
							'「扣繳憑單管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					EP30240: {
						name: ['保費明細管理', '保費明細管理[英文]', '保費明細管理'],
						url: '/ep30240',
						hint: [
							'「保費明細管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "保費明細管理" ...',
							'「保費明細管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					EP30310: {
						name: ['績效紀錄查詢設定', '績效紀錄查詢設定[英文]', '績效紀錄查詢設定'],
						url: '/ep30310',
						hint: [],
					},
				},
			},
			EP4: {
				name: ['主管專區', '主管專區[英文]', '主管專區'],
				children: {
					EP40110: {
						name: ['管轄權限設定', '管轄權限設定[英文]', '管轄權限設定'],
						url: '/ep40110',
						hint: [
							'「管轄權限設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "管轄權限設定" ...',
							'「管轄權限設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					// EP40120: {
					// 	name: ['部屬出缺勤查詢設定', '部屬出缺勤查詢設定[英文]', '部屬出缺勤查詢設定'],
					// 	url: '/ep40120',
					// 	hint: [
					// 		'「部屬出缺勤查詢設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "部屬出缺勤查詢設定" ...',
					// 		'「部屬出缺勤查詢設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					EP40130: {
						name: ['部屬個人資料查詢設定', '部屬個人資料查詢設定[英文]', '部屬個人資料查詢設定'],
						url: '/ep40130',
						hint: [
							'「部屬個人資料查詢設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "部屬個人資料查詢設定" ...',
							'「部屬個人資料查詢設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					EP40210: {
						name: ['部屬績效紀錄查詢設定', '部屬績效紀錄查詢設定[英文]', '部屬績效紀錄查詢設定'],
						url: '/ep40210',
						hint: [],
					}
				},
			},
			EP5: {
				name: ['排班', 'schedule', '排班'],
				children: {
					EP50110: {
						name: ['查看權限設定', 'View permission settings', '查看权限设定'],
						url: '/ep50110',
						hint: [
							'「查看權限設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "View permission settings" ...',
							'「查看权限设定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
			// EP6: {
			// 	name: ['AI專區', 'AI Zone', 'AI专区'],
			// 	children: {
			// 		EP60110: {
			// 			name: ['AI小夥伴', 'AI Buddies', 'AI小伙伴'],
			// 			url: '/ep60110',
			// 			hint: [],
			// 		},
			// 	},
			// },
			EP8: {
				name: ['用戶管理', '用戶管理[英文]', '用戶管理'],
				children: {
					EP80110: {
						name: ['帳號ID/密碼設定', '帳號ID/密碼設定[英文]', '帳號ID/密碼設定'],
						url: '/ep80110',
						hint: [
							'「帳號ID/密碼設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "帳號ID/密碼設定" ...',
							'「帳號ID/密碼設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					EP80210: {
						name: ['前台功能設定', '前台功能設定[英文]', '前台功能設定'],
						url: '/ep80210',
						hint: [
							'「前台功能設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "前台功能設定" ...',
							'「前台功能設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							EP80210: { name: ['帳號管理', '', ''] },
							EP80220: { name: ['權限規則設定', '', ''] },
							EP80230: { name: ['查詢個人資料規則設定', '', ''] },
							EP80240: { name: ['預設規則設定', '', ''] },
						},
					},
				},
			},
			EP9: {
				name: ['系統設定', '系統設定[英文]', '系統設定'],
				children: {
					// EP90110: {
					// 	name: ['歡迎詞設定', '歡迎詞設定[英文]', '歡迎詞設定'],
					// 	url: '/ep90110',
					// 	hint: [
					// 		'「歡迎詞設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "歡迎詞設定" ...',
					// 		'「歡迎詞設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					// EP90120: {
					// 	name: ['跑馬燈設定', '跑馬燈設定[英文]', '跑馬燈設定'],
					// 	url: '/ep90120',
					// 	hint: [
					// 		'「跑馬燈設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "跑馬燈設定" ...',
					// 		'「跑馬燈設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					// EP90130: {
					// 	name: ['首頁Banner設定', '首頁Banner設定[英文]', '首頁Banner設定'],
					// 	url: '/ep90130',
					// 	hint: [
					// 		'「首頁Banner設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "首頁Banner設定" ...',
					// 		'「首頁Banner設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					// EP90140: {
					// 	name: ['版面設定', '版面設定[英文]', '版面設定'],
					// 	url: '/ep90140',
					// 	hint: [
					// 		'「版面設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "版面設定" ...',
					// 		'「版面設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					// EP90150: {
					// 	name: ['參數功能設定', '參數功能設定[英文]', '參數功能設定'],
					// 	url: '/ep90150',
					// 	hint: [
					// 		'「參數功能設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "參數功能設定" ...',
					// 		'「參數功能設定」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					EP90170: {
						name: ['訊息通知', 'Notifications', '讯息通知'],
						url: '/ep90170',
						hint: [
							'「訊息通知」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Notifications" ...',
							'「讯息通知」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					// EP90160: {
					// 	name: ['線上說明', '線上說明[英文]', '線上說明'],
					// 	url: '/ep90160',
					// 	hint: [
					// 		'「線上說明」的說明文字的說明文字的說明文字的說明文字的說明文字...',
					// 		'Description for "線上說明" ...',
					// 		'「線上說明」的说明文字的说明文字的说明文字的说明文字的说明文字...',
					// 	],
					// },
					EP90130: {
						name: ['網站管理', '網站管理[英文]', '网站管理'],
						url: '/ep90130',
						hint: [
							'「Logo及瀏覽器標題」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Logo及瀏覽器標題" ...',
							'「Logo及瀏覽器標題」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
						children: {
							EP90130: { name: ['首頁Banner', '首頁Banner[英文]', '首页Banner'] },
							EP90140: { name: ['Logo及瀏覽器標題', 'Logo及瀏覽器標題[英文]', 'Logo及浏览器标题'] },
							EP90150: { name: ['登入頁背景圖', '登入頁背景圖[英文]', '登入页背景图'] },
						},
					},
				},
			},
		},
	},
	RPT: {
		shortName: ['報表', 'Report', '报表'],
		name: ['自訂報表', 'Customize', '自订报表'],
		ico: 'file-excel',
		hint: [
			'「自訂報表」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			'Description for "Customized Reports" ...',
			'「自订报表」的说明文字的说明文字的说明文字的说明文字的说明文字...',
		],
		children: {
			RPT1: {
				name: ['報表', 'Report', '报表'],
				children: {
					RPT10010: {
						name: ['自訂報表', 'Customize', '自订报表'],
						url: '/rpt10010',
						hint: [
							'「組織編制」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Organization Management" ...',
							'「组织编制」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
		},
	},

	CE: {
		shortName: ['碳管理', 'carbon management', '碳管理'],
		name: ['碳管理', 'carbon evaluate', '碳管理'],
		// 設計使用的icon 並非 fontawesome 的圖庫 所以這邊有空格 渲染出 earth-leaf-32-filled 的class 再使用css渲染
		ico: ' earth-leaf-32-filled',
		hint: [
			'「碳管理」的說明文字的說明文字的說明文字的說明文字的說明文字...',
			'Description for "Carbon Management" ...',
			'「碳管理」的说明文字的说明文字的说明文字的说明文字的说明文字...',
		],
		children: {
			CE1: {
				name: ['碳盤查', 'Carbon Audit', '碳盘查'],
				children: {
					CE20020: {
						name: ['員工通勤方式查詢', 'employee commute inquiry', '员工通勤方式查询'],
						url: '/ce20020',
						hint: [
							'「員工通勤方式查詢」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee Commute Inquiry" ...',
							'「员工通勤方式查询」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						]
					},
					CE20010: {
						name: ['年度碳排計算', 'annual carbon emissions calculation', '年度碳排计算'],
						url: '/ce20010',
						hint: [
							'「年度碳排計算」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Annual Carbon Emissions Calculation" ...',
							'「年度碳排计算」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						]
					},
				},
			},
			CE2: {
				name: ['參數設定', 'category setting', '参数设定'],
				children: {
					CE10010: {
						name: ['員工通勤填寫設定', 'employee commute form setting', '员工通勤填写设置'],
						url: '/ce10010',
						hint: [
							'「員工通勤填寫設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Employee Commute Form Setting" ...',
							'「员工通勤填写设置」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
					CE10020: {
						name: ['碳排係數設定', 'carbon emission factor settings', '碳排放系数设置'],
						url: '/ce10020',
						hint: [
							'「碳排係數設定」的說明文字的說明文字的說明文字的說明文字的說明文字...',
							'Description for "Carbon Emission Factor Settings" ...',
							'「碳排放系数设置」的说明文字的说明文字的说明文字的说明文字的说明文字...',
						],
					},
				},
			},
		},
	},

	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ_COMMON_3: {
				name: ['人事', 'Staff', '人事'],
				children: {
					ZZ_COMMON_ED10010: {
						name: ['員工類型', 'Employee kind settings', '员工类型'],
						url: '/zz_common_ed10010',
						hint: [],
					}
				},
			},
			ZZ_COMMON_1: {
				name: [`出勤`, `Attendance hours`, `出勤`],
				children: {
					ZZ_COMMON_AM10020: {
						name: ['出勤模擬試算', 'Attendance Simulation', '出勤模拟试算'],
						url: '/zz_common_am10020',
						hint: [],
					},
					ZZ_COMMON_AM10030: {
						name: ['請假不合併計算假勤設定', 'Leave Combine Setting', '请假不合并计算假勤设定'],
						url: '/zz_common_am10030',
						hint: [],
					},
				},
			},
			ZZ_COMMON_2: {
				name: ['薪資報表', 'Salary report', '薪资报表'],
				children: {
					ZZ_COMMON_PB10040: {
						name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'],
						url: '/zz_common_pb10040',
						hint: [],
					},
					ZZ_COMMON_PB10041: {
						name: ['薪資報表', 'Salary report', '薪资报表'],
						url: '/zz_common_pb10041',
						hint: [],
					},
				},
			},
		},
	},
};

let paidMenu = PAID_MODULES.reduce((acc, module) => {
	acc[module] = menu[module];
	return acc;
}, {});

let customize;
const sno = (typeof window === 'undefined') ? process.env.SNO : window.sno;
if (sno) {
	try {
		customize = require(`../customize/${sno}/constants/menu`);
	} catch (err) {

	}
}
const getMenu = (paidMenu, customize) => {
	if (customize) {
		const custMenu = customize();
		if (custMenu?.ZZ?.children) {
			paidMenu.ZZ = {
				...paidMenu.ZZ,
				children: { ...paidMenu.ZZ.children, ...custMenu.ZZ.children }
			};
		}
		return paidMenu;
	} else {
		return paidMenu;
	}
};
module.exports = Object.freeze({
	MENU: getMenu(paidMenu, customize),
	MENU_DEV: {
		DEV: {
			shortName: ['_開發', '_Dev', '_開發'],
			name: ['開發測試', 'Development', '開發測試'],
			ico: 'code',
			hint: ['開發測試', 'Development', '開發測試'],
			children: {
				BASIC: {
					name: ['基礎', 'Foundation', '基础'],
					children: {
						DEV10040: {
							name: ['Inputs', 'Inputs', 'Inputs'],
							url: '/_dev/basic/inputs',
							hint: ['Inputs'],
						},
						DEV10010: {
							name: ['Non/EmpUtils', 'Non/EmpUtils', 'Non/EmpUtils'],
							url: '/_dev/basic/empUtils',
							hint: ['Non/EmpUtils'],
						},
						DEV10020: {
							name: ['DataLoader', 'DataLoader', 'DataLoader'],
							url: '/_dev/basic/dataLoader',
							hint: ['DataLoader'],
						},
						DEV10090: {
							name: ['Test', 'Test', 'Test'],
							url: '/_dev/basic/test',
						},
					},
				},
				SAMPLE: {
					name: ['範例', 'Sample', '範例'],
					children: {
						IMPORT: {
							name: ['匯入', 'Import', '匯入'],
							url: '/_dev/sample/import',
							hint: ['匯入範例', 'Sample for import', '匯入範例'],
						},
						EXPORT: {
							name: ['匯出', 'Export', '匯出'],
							url: '/_dev/sample/export',
							hint: ['匯出範例', 'Sample for export', '匯出範例'],
						},
						inputSwitching: {
							name: ['Input Switching', 'Export', '匯出'],
							url: '/_dev/sample/inputSwitching',
							hint: ['輸入元件切換與值的關聯'],
						},
						RDG: {
							name: ['Another-Grid', 'Another-Grid', 'Another-Grid'],
							url: '/_dev/sample/another-grid',
						},
						LTP: {
							name: ['範例(Peayton)', '範例(Peayton)', '範例(Peayton)'],
							url: '/_dev/sample/peayton',
							hint: ['範例hint(Peayton)', '範例hint(Peayton)', '範例hint(Peayton)'],
						},
					},
				},
				TOOL: {
					name: ['自動工具', 'Tools', '自动工具'],
					children: {
						ZZ10010: {
							name: ['資料驗證生成', 'Validator', '资料验证生成'],
							url: '/_dev/tool/z1',
							hint: ['自動產生資料庫驗證的代碼', 'Generate DB validating code snippet', '自动产生资料库验证的代码'],
						},
						ZZ10020: {
							name: ['匯入匯出範例', 'Import & Export', '匯入匯出範例'],
							url: '/_dev/tool/z2',
							hint: ['匯入匯出範例', 'Import & Export', '匯入匯出範例'],
						},
						// ZZ10030: {
						// 	name: ['員工生效作業', 'Employee Effective', '員工生效作業'],
						// 	url: '/_dev/tool/z3',
						// 	hint: ['員工生效作業', 'Employee Effective', '員工生效作業'],
						// },
						// ZZ10040: {
						// 	name: ['組織圖生效作業', 'Organization chart effective operation', '组织图生效作业'],
						// 	url: '/_dev/tool/z4',
						// 	hint: ['組織圖生效作業', 'Organization chart effective operation', '组织图生效作业'],
						// },
						ZZ10050: {
							name: ['刷卡匯入測試', 'clock format test', '刷卡匯入測試'],
							url: '/_dev/tool/z5',
							hint: ['刷卡匯入測試', 'clock format test', '刷卡匯入測試'],
						},
						ZZ10210: {
							name: ['類目匯入工具', '類目匯入工具(En)', '類目匯入工具(Cn)'],
							url: '/_dev/tool/zz10210',
							hint: ['類目匯入工具', '類目匯入工具(En)', '類目匯入工具(Cn)'],
						},
					},
				},
			},
		},
	},
	utils: {
		getMenu: (menus, url) => {
			let found = null;
			const _find = (src) => _.forEach(src, m => {
				if (found) return;
				if (m.url === url) return found = m;
				else _find(m.children);
			});
			_find(menus);
			return found;
		},
	}
});
